/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_Restore_Failed1Inputs */

const vi_cmstools_restore_failed1 = /** @type {(inputs: Cmstools_Restore_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không khôi phục được. Kiểm tra mạng rồi thử lại.`)
};

/**

* @param {Cmstools_Restore_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_restore_failed1 = /** @type {((inputs?: Cmstools_Restore_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Restore_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_restore_failed1(inputs)
});
export { cmstools_restore_failed1 as "cmsTools_restore_failed" }